import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus\"><path d=\"M853.333 490.667h-320v-320c0-12.8-8.533-21.334-21.333-21.334s-21.333 8.534-21.333 21.334v320h-320c-12.8 0-21.334 8.533-21.334 21.333s8.534 21.333 21.334 21.333h320v320c0 12.8 8.533 21.334 21.333 21.334s21.333-8.534 21.333-21.334v-320h320c12.8 0 21.334-8.533 21.334-21.333s-8.534-21.333-21.334-21.333z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/plus.svg
// module id = f+Cd
// module chunks = 65